import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import AnimalDetailPage from "../Component/AnimalDetailPage";
import { animals } from "../data";


const AnimalDetailPageContainer = () =>{
    const {id} = useParams();
    const navigate = useNavigate();
    const [animalData, setAnimalData] = useState();

    useEffect(()=>{
        const animal = animals.find((animal) => animal.id === +id);
        if(animal) {
            setAnimalData(animal);
        }
    },[id])

    const handleGoBack = () => {
        navigate(-1);
    }

    return(
        <AnimalDetailPage animalData={animalData} handleGoBack={handleGoBack}/>
    );
}

export default AnimalDetailPageContainer;